import { useSelector } from "react-redux";

import {
    type LeadsSearchResponseDto,
    type LeadsType,
    selectListsSearchResultsDtoByLeadsType,
} from "app/pages/sales-intelligence/modules/leads-search";

import { useLeadsSearchResultsQuery } from "./useLeadsSearchResultsQuery";

const useLeadsSearchResult = <T = LeadsSearchResponseDto>(
    leadsType: LeadsType,
    select?: (data: LeadsSearchResponseDto) => T,
) => {
    const dtoByType = useSelector(selectListsSearchResultsDtoByLeadsType);

    // isEnabled - false - because this hook works as selector only. Data fetching in useLeadsSearchResultsQueries
    return useLeadsSearchResultsQuery(leadsType, dtoByType[leadsType], false, select);
};

export default useLeadsSearchResult;
